let navigator: any;

const setNavigator = (nav: any) => {
  navigator = nav;
};

const navigate = (path: string) => {
  if (navigator) {
    navigator.push(path);
  } else {
    console.warn("Navigator is not set!");
  }
};

export { setNavigator, navigate };
